/**
 * api.js — all Firestore *writes* should go through this module.
 *
 * In Milestone 1, calls go directly to Firestore via the Firebase SDK for
 * rapid iteration. Once the Cloudflare Worker is deployed and tested, swap
 * the implementations below to route through VITE_WORKER_URL instead.
 *
 * The Worker validates the caller's PIN server-side before forwarding the
 * write, ensuring no client can bypass auth. Reads always go direct to
 * Firestore for speed (no latency hit).
 *
 * TODO (Milestone 2): Route all writes through the Worker.
 */

import {
  doc, setDoc, updateDoc, deleteDoc, addDoc, collection,
} from 'firebase/firestore';
import { db } from '../firebase';

// ── Direct Firestore write helpers (M1) ────────────────────────────────────

export async function writeDoc(path, data) {
  const ref = buildRef(path);
  await setDoc(ref, data, { merge: true });
}

export async function updateDocFields(path, data) {
  const ref = buildRef(path);
  await updateDoc(ref, data);
}

export async function deleteDocument(path) {
  const ref = buildRef(path);
  await deleteDoc(ref);
}

export async function addToCollection(collectionPath, data) {
  const ref = collection(db, collectionPath);
  const result = await addDoc(ref, data);
  return result.id;
}

// ── Helpers ────────────────────────────────────────────────────────────────

/**
 * Accept a slash-separated path string or a Firestore DocumentReference.
 * e.g. 'campaigns/default-campaign/tokens/abc123'
 */
function buildRef(path) {
  if (typeof path === 'string') {
    const parts = path.split('/');
    return doc(db, ...parts);
  }
  return path; // already a ref
}
